import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListFailedSubscriptions from '../../components/reports/list-failed-subscriptions.component';

const FailedSubscriptionsView = () => {
  const pageTitle = 'Analytics / Failed Subscription Logs';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListFailedSubscriptions />
    </AppLayout>
  );
};

export default FailedSubscriptionsView;
